import { Controller } from "stimulus";
import { M } from "@materializecss/materialize/dist/js/materialize";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {
  static get targets() {
    return ["select"];
  }

  static get values() {
    return { default: String };
  }

  connect() {
    M.FormSelect.init(this.selectTarget);
    dispatchCustomEvent(document, `${this.element.id}-loaded`);
    this.highlightIfHasSelected();
  }

  highlightIfHasSelected() {
    if (this.selectedValue === this.defaultValue) {
      this.input.classList.add(this.labelGrayColorCssClass); 
    } else {
      this.input.classList.remove(this.labelGrayColorCssClass);
    } 
  }

  resetSelection() {
    const form = M.FormSelect.getInstance(this.selectTarget);
    const defaultValueOption = form._values.find((v) => v.el.value === this.defaultValue);
    form._selectValue(defaultValueOption);
    this.highlightIfHasSelected();
    this.selectTarget.dispatchEvent(new Event("change"));
  }

  get input() {
    return this.element.querySelector("input");
  }

  get selectedOption() {
    return this.element.querySelector("select");
  }

  get selectedValue() {
    return this.element.querySelector("select").value;
  }

  get defaultValueOption() {
    return this.element.querySelector(`option[value="${this.defaultValue}"]`);
  }

  set selectedValue(value) {
    this.element.querySelector("select").value = value;
  }

  get labelGrayColorCssClass() {
    return "label-gray-color";
  }
}
